import React, { useState } from "react";
import styles from "./CreateNewUser.module.css";
import { useNavigate } from "react-router-dom";
import { IoIosArrowBack } from "react-icons/io";


import {
  Dropdown,
  InputField,
  TextComponent,
  SubmitButton,
} from "../../../components";

const CreateNewUser = () => {
  const navigate = useNavigate();

  const [fullName, setFullName] = useState("");
  const [branch, setBranch] = useState("");
  const [role, setRole] = useState({ value: "Select Role", id: 0 });
  const [department, setDepartment] = useState({
    value: "Select Department",
    id: 0,
  });
  const [email, setEmail] = useState("");
  const [designation, setDesignation] = useState("");
  const [password, setPassword] = useState("");


  const handleSubmit = () => {
    const formData = {
      fullName,
      branch,
      role: role.value,
      department: department.value,
      email,
      designation,
      password,
    };
                 navigate(-1)

    console.log("Submitted Data:", formData);
  };

  return (
    <div className={styles.mainCont}>
 
      <div className={styles.HeadingDiv}>
        <div className={styles.headingWrapper}>
          <IoIosArrowBack
            className={styles.backIcon}
            onClick={() => navigate(-1)}
          />

          <TextComponent
            className={styles.Heading}
            text={"Create New User"}
          />
        </div>
      </div>

   
      <div className={styles.subCont}>

        <div className={styles.leftCont}>
          <InputField
            className={styles.inputNew}
            label={"First & Last Name"}
            placeholder={"Stacy Doe"}
            value={fullName}
            onChange={(e) => setFullName(e.target.value)}
          />

          <InputField
            className={styles.inputNew}
            label={"Branch"}
            placeholder={"Main Branch"}
            value={branch}
            onChange={(e) => setBranch(e.target.value)}
          />

          <Dropdown
            label={"Role"}
            value={role}
            style={{ color: "var(--black-color)" }}
            options={[
              { value: "Supervisor", id: 1 },
              { value: "Manager", id: 2 },
              { value: "Staff", id: 3 },
              { value: "Trainee", id: 4 },
            ]}
            onChange={(selected) => setRole(selected)}
          />

          <Dropdown
            label={"Assigned Department"}
            value={department}
            style={{ color: "var(--black-color)" }}
            options={[
              { value: "Bakery", id: 1 },
              { value: "Production", id: 2 },
              { value: "Quality Control", id: 3 },
              { value: "Logistics", id: 4 },
            ]}
            onChange={(selected) => setDepartment(selected)}
          />
        </div>

        <div className={styles.rightCont}>
          <InputField
            className={styles.inputNew}
            label={"Email"}
            placeholder={"stacy.doe@example.com"}
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />

          <InputField
            className={styles.inputNew}
            label={"Designation"}
            placeholder={"Head Mixer"}
            value={designation}
            onChange={(e) => setDesignation(e.target.value)}
          />

          <InputField
            className={styles.inputNew}
            label={"Password"}
            placeholder={"********"}
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />

          <div className={styles.btnContainer}>
            <SubmitButton
              title={"Save"}
              primary
              onClick={handleSubmit}
              btnContainerClass={styles.Login_btnContainer}
              textClass={styles.Login_Text}
              btnClass={styles.Login_btn}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default CreateNewUser;
